/* eslint-disable react/no-unused-state */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { UserDO } from 'wdna-components';
import { DashComponent, DashboardLauncher } from 'wdna-components/lib/dashboards';
import { messageError } from 'wdna-components/lib/helpers/notification';
import { initProcess, finishProcess } from 'wdna-components/lib/scheduler/actions';

/* Types */
import { FilterContext } from '../../../../types';

/* Sidebar */
import MainFilter from '../components/addons/MainFilter';

import { waste } from '../../../sensors/requests';

/* Components */
import MainTable from '../components/drilldown/MainTable';

const dashConfig: DashComponent[] = [
  {
    widths: [12, 12, 12],
    component: MainTable,
    props: {
      title: 'Drilldown Table',
      loading: false,
    },
  },
];

interface Props {
  type: string;
  mainFilter: any;
}

interface State {
  mainFilter?: any;
  sidebar?: React.ReactNode[];
  dashboardData: any[];
}

class MainDashboard extends React.Component<Props, State> {
  private pid: string;

  public constructor(props: Props) {
    super(props);

    const { mainFilter } = props;

    this.pid = window.getStr();
    this.state = {
      mainFilter,
      sidebar: undefined,
      dashboardData: [],
    };
  }

  public componentDidMount(): void {
    this.fetchData();
  }

  public componentDidUpdate(prevProps: Props): void {
    if (this.props !== prevProps) {
      this.fetchData();
    }
  }

  public updateParent = (data: State, cb?: (() => void)): void => {
    this.setState({ ...data }, () => {
      if (typeof cb === 'function') cb();
    });
  }

  public fetchData = (): void => {
    window.store.dispatch(initProcess(this.pid));
    try {
      this.processSidebarConfig();
    } catch (error: any) {
      messageError('Error', error.message);
    }

    setTimeout(() => {
      window.store.dispatch(finishProcess(this.pid));
    }, 1000);
  };

  public processSidebarConfig = (): void => {
    const { mainFilter } = this.props;
    const sidebar: React.ReactNode[] = [(): JSX.Element => <MainFilter initialState={mainFilter} requestFunc={this.getDashboardData} />];

    this.setState({
      sidebar,
    });
  };

  public getDashboardData = async (): Promise<any> => {
    const { type } = this.props;
    const filter: any = this.state.mainFilter;

    const req: Record<string, any> = { type };
    if (!_.isEmpty(filter)) {
      req.from = filter.arrFilterDate[0].date1;
      req.to = filter.arrFilterDate[0].date2;
    }

    const user: UserDO = _.get(window.store.getState(), ['user', 'user']);
    const userType: string = (user && user.type) || 'cli';
    if (userType === 'cli') {
      req.verified = true;
      if (user.area_id && !isNaN(user.area_id)) {
        req.companyId = user.area_id;
      }
    } else {
      req.verified = filter.verified;
      req.companyId = filter.company;
    }

    return waste('unload_list', undefined, req);
  };

  public render(): React.ReactNode {
    const { sidebar } = this.state;
    if (!dashConfig || !sidebar) return null;
    return (
      <FilterContext.Provider value={{ parentState: this.state, updateParent: this.updateParent }}>
        <DashboardLauncher config={dashConfig} sidebar={sidebar} hiddenSidebar />
      </FilterContext.Provider>
    );
  }
}

const View: React.MemoExoticComponent<any> = React.memo((props: Props): JSX.Element => {
  return <MainDashboard {...props} />;
});

export default View;
